import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import Select from "../../form/Select";
import DateTimeInput from "../../form/DateTimeInput";
import {CurrencyFormatter, UnitFormatter} from "../../../utils/formatters";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {componentFilter} from "../../../utils/filters";
import TextInput from "../../form/TextInput";
import {loadComponent} from "../../../utils/components";
import {ifCompletedInput} from "../../../utils/other";
import TextArea from "../../form/TextArea";
import Confirm from "../../form/Confirm";
import classNames from "classnames";
import Button from "../../form/Button";

const sortable = true;
const filterable = true;

class ContractForm extends React.Component {

    state = {
        paging: null
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-md-5">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="provider"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Szolgáltató"
                        />
                    </div>
                    <div className="col-md-5">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="customer"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Partner"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <Select
                            {...this.props.getFieldProps("type")}
                            optionname="ContractType"
                            storeType="local"
                            objectValue={false}
                            isClearable={true}
                            name="type"
                            value={this.props.values.type}
                            label="Szerződés típusa"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="expiry"
                            isClearable={true}
                            fieldEditorType={DateTimeInput}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Szerződés vége"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        {!this.props.values[this.props.componentConfig.idfield] ? <SelectorGrid
                            ref={(e) => this.items = e}
                            className={"p-small-table"}
                            exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                            onPage={(paging) => {
                                this.setState({paging});
                            }}
                            onItemUpdate={async (newItem, oldItem, fieldName, rowIndex, {rowOffset}) => {
                                const items = [...this.props.values.items];
                                items[rowOffset] = newItem;
                                await this.props.setFieldValue('items', items);
                                this.items && this.items.loadDataBackground(null, this.state.paging, null);
                            }}
                            columns={{
                                "action": {
                                    header: <Button
                                        className={classNames("listfield-add btn-xs", {disabled: this.props.disabled || this.props.isLoading})}
                                        color="default" icon={{lib: "fa", name: "plus"}}
                                        onClick={(e) => {
                                            e && e.preventDefault();
                                            if (this.props.disabled || this.props.isLoading) return;
                                            let items = JSON.parse(JSON.stringify(this.props.values.items || []));
                                            items = [...items, {}];
                                            this.props.setFieldValue("items", items);
                                        }}
                                    />,
                                    width: 'cell-button',
                                    renderer: (value, rowData, rowIndex, {rowOffset}) => {
                                        return <Confirm
                                            onAccept={() => {
                                                this.props.setFieldValue("items", this.props.values.items.filter((i, index) => index !== rowOffset));
                                            }}
                                            color="danger"
                                            icon={{lib: "fa", name: "trash"}}
                                            className="btn-xs"
                                            header="Törlés"
                                            body="Biztosan törlöd ezt a tételt?"
                                            acceptButton="Törlés"
                                        />
                                    }
                                },
                                "name": {
                                    header: 'Megnevezés',
                                    width: 4,
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <TextInput
                                                    name="name"
                                                    label={false}
                                                    focus={true}
                                                    value={value}
                                                    onKeyDown={(e, field, value) => {
                                                        ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                    }}
                                                    onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                                />
                                },
                                "calculator": {
                                    header: 'Kalkulátor',
                                    width: 2,
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <Select
                                                    name="calculator"
                                                    optionname="ContractItemCalculator"
                                                    objectValue={false}
                                                    label={false}
                                                    storeType="local"
                                                    value={value}
                                                    focus={true}
                                                    saveChanges={(field, value) => {
                                                        parent.onEditorValueChange(props, value);
                                                    }}
                                                />
                                },
                                "listprice": {
                                    header: 'Listaár',
                                    width: 2,
                                    sortable,
                                    filterable,
                                    renderer: CurrencyFormatter,
                                    className: "currency",
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <TextInput type="decimal" name="listprice" label={false} focus={true}
                                                           value={value}
                                                           onKeyDown={(e, field, value) => {
                                                               ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                           }}
                                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                                },
                                "vat": {
                                    header: "Áfa",
                                    width: "vat",
                                    sortable,
                                    filterable: componentFilter({component: "vatrate"}),
                                    renderer: (value) => <span className="vat">{value?.name}</span>,
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <Select
                                                    name="vat"
                                                    component="vatrate"
                                                    filter={{field: "active", value: 1}}
                                                    objectValue={true}
                                                    label={false}
                                                    storeType="local"
                                                    value={value}
                                                    view={["rate"]}
                                                    focus={true}
                                                    saveChanges={(field, value) => {
                                                        parent.onEditorValueChange(props, value);
                                                    }}
                                                />
                                },
                                "unit": {
                                    header: 'Mértékegység',
                                    sortable,
                                    filterable,
                                    renderer: (value, row) => <span className="unit">{value}</span>,
                                    className: "unit",
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <TextInput
                                                    name="unit"
                                                    label={false}
                                                    focus={true}
                                                    value={value}
                                                    onKeyDown={(e, field, value) => {
                                                        ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                    }}
                                                    onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                                />
                                },
                                "comment": {
                                    header: 'Megjegyzés',
                                    width: 1,
                                    sortable,
                                    filterable,
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <TextArea name="comment" label={false} focus={true}
                                                          value={value}
                                                          onKeyDown={(e, field, value) => {
                                                              ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                          }}
                                                          onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                                },
                            }}
                            //name="items"
                            //data={this.props.values}
                            orderBy={{field: "id", direction: "ASC"}}
                            //componentConfig={this.props.componentConfig}
                            value={this.props.values.items || []}
                            component="ContractItem"

                        />
                        :
                        <SelectorGrid
                            {...this.props.getFieldProps("items")}
                            ref={(e) => this.items = e}
                            className={"p-small-table"}
                            addRowFunction={({addNewRows}) => {
                                addNewRows([{}]);
                            }}
                            onItemUpdate={true}
                            columns={{
                                "id": {
                                    header: 'Kód',
                                    sortable,
                                    filterable
                                },
                                "name": {
                                    header: 'Megnevezés',
                                    width: 5,
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <TextInput
                                                    name="name"
                                                    value={value}
                                                    label={false}
                                                    focus={true}
                                                    suggestion={undefined /*async (value) => {
                                                        return (await loadComponent(this.props.componentConfig.fielddefs.items.objects, {
                                                            limit: 1,
                                                            filter: {field: "name", value: value, operator: "LIKE", matchmode: "start"}
                                                        })).name;
                                                    }*/}
                                                    saveChanges={(field, value) => {
                                                        parent.onEditorValueChange(props, value);
                                                    }}
                                                />
                                },
                                "calculator": {
                                    header: 'Kalkulátor',
                                    width: 2,
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <Select
                                                    name="calculator"
                                                    optionname="ContractItemCalculator"
                                                    objectValue={false}
                                                    label={false}
                                                    storeType="local"
                                                    value={value}
                                                    focus={true}
                                                    saveChanges={(field, value) => {
                                                        parent.onEditorValueChange(props, value);
                                                    }}
                                                />
                                },
                                "listprice": {
                                    header: 'Listaár',
                                    width: 1,
                                    sortable,
                                    filterable,
                                    renderer: CurrencyFormatter,
                                    className: "currency",
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <TextInput type="decimal" name="listprice" label={false} focus={true}
                                                           value={value}
                                                           onKeyDown={(e, field, value) => {
                                                               ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                           }}
                                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                                },
                                "vat": {
                                    header: "Áfa",
                                    width: "vat",
                                    sortable,
                                    filterable: componentFilter({component: "vatrate"}),
                                    renderer: (value) => <span className="vat">{value?.name}</span>,
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <Select
                                                    name="vat"
                                                    component="vatrate"
                                                    filter={{field: "active", value: 1}}
                                                    objectValue={true}
                                                    label={false}
                                                    storeType="local"
                                                    value={value}
                                                    view={["rate"]}
                                                    focus={true}
                                                    saveChanges={(field, value) => {
                                                        parent.onEditorValueChange(props, value);
                                                    }}
                                                />
                                },
                                "unit": {
                                    header: 'Mértékegység',
                                    sortable,
                                    filterable,
                                    renderer: (value, row) => <span className="unit">{value}</span>,
                                    className: "unit",
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <TextInput name="unit" label={false} focus={true}
                                                           value={value}
                                                           onKeyDown={(e, field, value) => {
                                                               ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                           }}
                                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                                },
                                "comment": {
                                    header: 'Megjegyzés',
                                    width: 1,
                                    sortable,
                                    filterable,
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <TextArea name="comment" label={false} focus={true}
                                                           value={value}
                                                           onKeyDown={(e, field, value) => {
                                                               ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                           }}
                                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                                },
                            }}
                            name="items"
                            data={this.props.values}
                            orderBy={{field: "id", direction: "DESC"}}
                            componentConfig={this.props.componentConfig}
                        />}
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(ContractForm);
